import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export const PayNearMe = (props) => {

    const initializePayNearMe = (token, paymentAmount) => {
        window.PNM.init({
            'order_token': token,
            "callback": callback,
            "target": "pnm-target",
            'auto_resize': true,
            'language': 'en',
            "header_size": "0",
            "header_bkgnd": "ffffff",
            "header_color": "ffffff",

            'actions': {
                'Pay': {
                    'action': 'pay',
                    'header': 'Make a Payment',
                    'debit': props.allowDebit,
                    'ach': props.allowAch,
                    'apple_pay': props.allowApplePay,
                    'google_pay': props.allowGooglePay,
                    'venmo': props.allowVenmo,
                    'paypal': props.allowPayPal,
                    'cash': props.allowCash,
                    'cash_app': props.allowCashApp,
                    'payment_amount': paymentAmount,
                    'display_receipt': true
                }
            },
        });
        window.PNM.launch('Pay');
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if (window.PNM === undefined) {
                return;
            }

            initializePayNearMe(props.smartToken, props.paymentAmount);
            clearInterval(interval)
        }, 1000)

        return () => clearInterval(interval);

    }, [props.smartToken])

    useEffect(() => {

        const head = document.querySelector("head");
        const script = document.createElement("script");

        script.setAttribute("src", props.embeddedClientUrl);
        head.appendChild(script);

        return () => {
            head.removeChild(script);
        }

    }, []);

    const callback = (data) => {
        if (!data.status) {
            // status should always be present 
            // for any messages posted by the PNM iFrame.
            return;
        }

        if (data.status === 'error') {
            props.onMessage("PAYMENT_ERROR");
        }

        if (data.status === 'exit' ) {
            props.onMessage("PAYMENT_CANCEL");
        }

        if (data.status === 'complete') {
            props.onMessage("PAYMENT_SUCCESS");
        }
    };

    return (
        <div>
            <div id='pnm-target' style={{ display: 'flex', width: '740px', minHeight: '400px' }}></div>
        </div>
    )
}

PayNearMe.propTypes = {
    paymentAmount: PropTypes.number.isRequired, 
    embeddedClientUrl: PropTypes.string.isRequired, 
    smartToken: PropTypes.string.isRequired, 
    onMessage: PropTypes.func.isRequired, 
    allowDebit: PropTypes.bool,
    allowAch: PropTypes.bool,
    allowGooglePay: PropTypes.bool,
    allowApplePay: PropTypes.bool,
    allowPayPal: PropTypes.bool,
    allowVenmo: PropTypes.bool,
    allowCashApp: PropTypes.bool,
    allowCash: PropTypes.bool
}

PayNearMe.defaultProps = {
    allowDebit: true,
    allowAch: true,
    allowGooglePay: true,
    allowApplePay: true,
    allowPayPal: true,
    allowVenmo: true,
    allowCashApp: true,
    allowCash: true
}